import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

function Button({ message, buttonClasses = '' }) {
  return (
    <button
      type="button"
      className={classNames(
        buttonClasses,
        'border-none',
        'box-shadow-none',
        'border-radius-level-1',
        'text-size-secondary',
        'margin-right-sm',
        'text-weight-500',
        'padding-horizontal-xs',
        'padding-vertical-xxs',
        'transition-normal',
        'background-grey-7',
        'color-white',
        'cursor-disabled',
      )}
      disabled
    >
      <FormattedMessage {...message} />
    </button>
  );
}

Button.propTypes = {
  message: PropTypes.object,
  hasPermission: PropTypes.bool,
  buttonClasses: PropTypes.string,
};

export default Button;
